export default __webpack_public_path__ + "static/media/Tutorial-Step-5.65cc88a9.jpg";